/**
 * Helpers for {@link PrivateRoute} path policy (e.g. fulfillment-center gate).
 */

export function settingsPathAllowsNoFulfillmentCenter(
  normalizedPathname: string
): boolean {
  return (
    normalizedPathname === "/settings" ||
    normalizedPathname === "/settings/general"
  );
}
